import { Injectable } from '@angular/core';
import { AuthService } from '@app/auth.service';
interface isLoggedIn {
  status: boolean
}

interface logoutStatus {
  status: boolean
}

@Injectable()
export class UserService {

  constructor(private Auth: AuthService) { }

  isLoggedIn() {
    const result: isLoggedIn = {
      status: false
    };

    const cookieData = JSON.parse(localStorage.getItem('dpa_cc'));
    if (cookieData != null && cookieData.userId != null && cookieData.userId != "") {
      result.status = true;
    }
    return result;
  }

  logout() {
    localStorage.setItem('dpa_cc', null);
    this.Auth.setLoggedIn(false);
    const result: isLoggedIn = {
      status: false
    };
    return result;
  }


}



// WEBPACK FOOTER //
// ./src/app/user.service.ts